// Per-recon column rules that ReconTable applies on top of the wire's `recon.columns` order —
// kept apart from reconciliationsCopy.ts (which is tooltip/caption text) because these are
// structural (what renders at all, and what glyph a header carries), not wording.

// The header `+ / − / =` glyph (A-145), keyed by recon id THEN column key — never by column key
// alone, since a key like `equityPas3` or `debtSchedule` is reused across recons with different
// meaning (e.g. debtSchedule is '=' under Debt but carries no operator under New Sanctions).
export const COLUMN_OPERATORS: Record<string, Record<string, '+' | '−' | '='>> = {
    accountReceivables: { revenueSourceGst: '+', revenueSourcePnl: '+', collections: '−', revenueGst: '=', revenuePnl: '=' },
    accountPayables: { expensesPnl: '+', payments: '−', expectedPayables: '=' },
    cashBurn: { investingNetCfs: '+', cashBurnCfs: '=' },
    debt: { newDebt: '+', newDebtDs: '+', repayments: '−', repaymentsDs: '−', debtBank: '=', debtSchedule: '=' },
    netWorth: { pat: '+', equityPas3: '+', calculatedNetWorth: '=' },
};

export const columnOperator = (reconId: string, columnKey: string): string | undefined => COLUMN_OPERATORS[reconId]?.[columnKey];

// Columns present on the wire but never rendered as a table column. New Sanctions: the ticket
// lists five source columns and no calculated column (user decision) — the max-of-sources figure
// stays in the payload (every score is unchanged) but the benchmark column itself is hidden.
export const HIDDEN_COLUMN_KEYS: Record<string, string[]> = {
    newSanctions: ['newSanctionsMax'],
};
